/* Common */
export const HOMEPAGE = '/';
export const DASHBOARD = "/dashboard";
export const LOGIN = "/login";

/* App */
export const APPLICATION_PAGE = "/app/:appId";
export const ADD_APPLICATION_PAGE = "/add/app";
export const EDIT_APPLICATION_PAGE = APPLICATION_PAGE + "/edit";
export const SETTING_PAGE = APPLICATION_PAGE + "/settings";
export const APPLICATION_MODULE_PAGE = APPLICATION_PAGE + "/:module";

/* OpenExplore */
export const OPENEXPLORE_PAGE = APPLICATION_PAGE + "/openexplore";
export const OPENEXPLORE_MAP_PAGE = OPENEXPLORE_PAGE + "/map";
export const OPENEXPLORE_LIST_PAGE = OPENEXPLORE_PAGE + "/list";
export const POINT_PAGE = OPENEXPLORE_PAGE + "/points/:pointId";
export const ADD_POINT_PAGE = OPENEXPLORE_PAGE + "/add/points";
export const EDIT_POINT_PAGE = OPENEXPLORE_PAGE + "/points/:pointId/edit";
export const TRAIL_PAGE = OPENEXPLORE_PAGE + "/trails/:trailId";
export const ADD_TRAIL_PAGE = OPENEXPLORE_PAGE + "/add/trails";
export const EDIT_TRAIL_PAGE = OPENEXPLORE_PAGE + "/trails/:trailId/edit";
export const EDIT_OPENEXPLORE_MEDIA_PAGE = OPENEXPLORE_PAGE + "/:entityType/:entityId/medias/:mediaId/edit";
export const MIME_MEDIA_LIST_PAGE = OPENEXPLORE_PAGE + "/:entityType/:entityId/medias/mime/:shortMime";

/* Comment */
export const COMMENTS_PAGE = APPLICATION_PAGE + "/comments";

/* Push */
export const PUSH_PAGE = APPLICATION_PAGE + "/push";
export const ADD_PUSH_SOUND_PAGE = APPLICATION_PAGE + "/settings/pushsounds/add";
export const ADD_PUSH_GROUP_PAGE = APPLICATION_PAGE + "/settings/pushgroups/add";

/* Report */
export const REPORT_PAGE = APPLICATION_PAGE + "/report/:reportId";
export const EDIT_REPORT_PAGE = REPORT_PAGE + "/edit";
export const REPORTS_PAGE = APPLICATION_PAGE + "/reports";
export const REPORTS_MAP_PAGE = REPORTS_PAGE + "/map";
export const REPORTS_LIST_PAGE = REPORTS_PAGE + "/list";

/* ReportSubject */
export const REPORTSUBJECT_PAGE = APPLICATION_PAGE + "/reportsubjects/:reportsubjectId";
export const ADD_REPORTSUBJECT_PAGE = APPLICATION_PAGE + "/add/reportsubjects";
export const EDIT_REPORTSUBJECT_PAGE = REPORTSUBJECT_PAGE + "/edit";

/* Admin  and Profile */
export const ADMIN_PAGE = "/admin/:adminId";
export const EDIT_ADMIN_PAGE = "/admin/:adminId/edit";
export const ADD_ADMIN_PAGE = "/add/admin";
export const PROFILE_PAGE = "/profile";
export const EDIT_PROFILE_PAGE = "/profile/edit";
export const EDIT_PASSWORD_PAGE = "/profile/edit/password";

/* Custom fields */
export const ADD_CF_TRAIL_PAGE = APPLICATION_PAGE + "/customfields/trails/add";
export const ADD_CF_POINT_PAGE = APPLICATION_PAGE + "/customfields/points/add";
export const ADD_CF_NEWS_PAGE = APPLICATION_PAGE + "/customfields/news/add";
export const ADD_CF_ACHIEVEMENT_PAGE = APPLICATION_PAGE + "/customfields/achievements/add";
export const EDIT_CF_PAGE = APPLICATION_PAGE + "/customfields/:customFieldId/edit";

/* Types */
export const TYPE_PAGE = APPLICATION_PAGE + "/types/:typeId";
export const ADD_TYPE_PAGE = APPLICATION_PAGE + "/add/types";
export const EDIT_TYPE_PAGE = TYPE_PAGE + "/edit";
export const MEDIA_TYPE_PAGE = APPLICATION_PAGE + "/mediatypes/:mediaTypeId";
export const ADD_MEDIA_TYPE_PAGE = APPLICATION_PAGE + "/add/mediatypes";
export const EDIT_MEDIA_TYPE_PAGE = MEDIA_TYPE_PAGE + "/edit";

/* News */
export const NEWS_LIST_PAGE = APPLICATION_PAGE + "/news";
export const NEWS_PAGE = APPLICATION_PAGE + "/news/:newsId";
export const ADD_NEWS_PAGE = APPLICATION_PAGE + "/add/news";
export const EDIT_NEWS_PAGE = NEWS_PAGE + "/edit";
export const EDIT_NEWS_MEDIA_PAGE = NEWS_PAGE + "/medias/:mediaId/edit";
export const NEWS_MIME_MEDIA_LIST_PAGE = NEWS_PAGE + "/medias/mime/:shortMime";

/* Page */
export const PAGE_PAGE = APPLICATION_PAGE + "/pages/:pageId";
export const ADD_PAGE_PAGE = APPLICATION_PAGE + "/add/pages";
export const PAGE_LIST_PAGE = APPLICATION_PAGE + "/pages";
export const EDIT_PAGE_PAGE = PAGE_PAGE + "/edit";
export const PAGE_MIME_MEDIA_LIST_PAGE = PAGE_PAGE + "/medias/mime/:shortMime";
export const EDIT_PAGE_MEDIA_PAGE = PAGE_PAGE + "/medias/:mediaId/edit";

/* Road book */
export const ROAD_BOOKS_PAGE = APPLICATION_PAGE + "/road-books";
export const ROAD_BOOK_CONFIGURATION_PAGE = ROAD_BOOKS_PAGE + "/available/:roadBookConfigurationId";
export const ADD_ROAD_BOOK_CONFIGURATION_PAGE = APPLICATION_PAGE + "/add/road-books";
export const EDIT_ROAD_BOOK_CONFIGURATION_PAGE = ROAD_BOOK_CONFIGURATION_PAGE + "/edit";

/* Gamification */
export const GAMIFICATIONS_PAGE = APPLICATION_PAGE + "/gamification";
export const ADD_ACHIEVEMENT_PAGE = GAMIFICATIONS_PAGE + "/add/achievements";
export const ACHIEVEMENT_PAGE = GAMIFICATIONS_PAGE + "/achievements/:achievementId";
export const EDIT_ACHIEVEMENT_PAGE = ACHIEVEMENT_PAGE + "/edit";

/* Quiz */

export const QUIZZES_PAGE = APPLICATION_PAGE + "/quizzes";
export const ADD_QUIZ_PAGE = QUIZZES_PAGE + "/add/quizzes";
export const QUIZ_PAGE = QUIZZES_PAGE + "/:quizId";
export const EDIT_QUIZ_PAGE = QUIZ_PAGE + "/edit";

/* AccessToken */
export const ACCESS_TOKEN_PAGE = APPLICATION_PAGE + "/access-tokens";
export const ADD_ACCESS_TOKEN_PAGE = ACCESS_TOKEN_PAGE + "/add/access-tokens";



// WEBPACK FOOTER //
// src/constants/routes.js